/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import React from 'react';

import { EpisodeInfo } from 'client-code/episode-guide';

import { TiVoMemo } from '../../../core/tivo/tivo-react-wrapper';
import { ListTypes } from '../../../core/utils';
import { Mousetrap } from '../../common';
import { ProgressBar } from '../../common/ProgressBar';

interface OnDemandListItemProps {
    episode: EpisodeInfo;
    index: number;
    isSelected: boolean;
    ghostMode: boolean;
    itemClass?: string;
}

const OnDemandListItem: React.FC<OnDemandListItemProps> = ({
    episode,
    index,
    itemClass,
    isSelected,
    ghostMode,
}) => {
    const formatEpisodeNumber = (season?: number, epi?: number): string => {
        const seasonStr = season ? `S${season}` : '';
        const episodeStr = epi ? `E${epi}` : '';
        return `${seasonStr} ${episodeStr}`.trim();
    };

    const episodeClasses = `od-episode-item ${isSelected ? itemClass : ''} ${isSelected && ghostMode ? 'ghostHighlight' : ''}`;

    return (
        <div key={`episode-container-${episode.contentId}`} className="od-episode-container">
            <Mousetrap
                key={`episode-${episode.contentId}`}
                value={`${index}_${ListTypes.ON_DEMAND_LIST}`}
                className={episodeClasses}
            >
                <div className="od-episode-info">
                    <span className="od-episode-number">
                        {formatEpisodeNumber(episode.seasonOrYear, episode.episodeNum)}
                    </span>
                    <span className="od-episode-title">&lsquo;{episode.title}&rsquo;</span>
                </div>
                {episode.percentWatched !== undefined && episode.percentWatched > 0 && (
                    <div className="od-progress-bar">
                        <ProgressBar percentage={episode.percentWatched} />
                    </div>
                )}
            </Mousetrap>
        </div>
    );
};

export default TiVoMemo(OnDemandListItem);
